import validate from './validate';
import {
  estimateRenderedSmsLength,
  measureSmsLength,
  NO_LINK_SHORTENING_COUNTRIES,
} from './smsLength';

// A stored template sent as is goes by id, so the server never checks its text.
export function isStoredTemplateAsIs({ smsSelectedTemplate, smsText }) {
  return Boolean(
    smsSelectedTemplate &&
    smsSelectedTemplate.id &&
    smsSelectedTemplate.id !== '__no_template__' &&
    smsSelectedTemplate.sms_text === smsText,
  );
}

// The drawer renders the length message from the live text under its counter, so it clears as
// the text changes. The key only blocks the submit. The cap is Bird's, so an account on another
// provider is never blocked.
export default function validateBulk(values, usingBird) {
  const errors = validate(values);

  if (
    usingBird &&
    !isStoredTemplateAsIs(values) &&
    measureSmsLength(values.smsText).exceedsLimit
  ) {
    errors.smsLength = true;
  }

  return errors;
}

// A send this blocks gets no warning. Otherwise it warns without blocking: a stored template goes
// by id, and a merge key's length is known only per applicant. Delivery fails what goes over.
export function smsLengthWarning(values, usingBird, countryCode) {
  if (!usingBird) return null;

  const typedLength = measureSmsLength(values.smsText);
  if (typedLength.exceedsLimit && !isStoredTemplateAsIs(values)) return null;

  // The user's account country; a sub-account's or an opening location number's is not checked.
  const renderedLength = estimateRenderedSmsLength(values.smsText, {
    shortensLinks: !NO_LINK_SHORTENING_COUNTRIES.includes(countryCode),
  });
  if (!renderedLength.exceedsLimit) return null;

  return renderedLength.fixedTextExceedsLimit ? 'exceeds' : 'mayExceed';
}
